<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="{ name: 'home' }">
          <img :src="connectLogo" style="color: white;" alt="logo" />
          <span class="is-capitalized has-text-weight-bold"
            >Datalized Connect</span
          >
        </router-link>
        <span
          class="navbar-burger burger"
          data-target="navbarMenu"
          :class="{ 'is-active': isOpen }"
          @click="isOpen = !isOpen"
        >
          <span></span>
          <span></span>
          <span></span>
        </span>
      </div>
      <div id="navbarMenu" class="navbar-menu" :class="{ 'is-active': isOpen }">
        <div class="navbar-end">
          <router-link
            active-class="is-active"
            class="navbar-item"
            role="button"
            exact
            :to="{ name: 'home' }"
            >Inicio</router-link
          >
          <router-link
            active-class="is-active"
            class="navbar-item"
            role="button"
            :to="{ name: 'integrations' }"
            >Integraciones</router-link
          >
          <router-link
            active-class="is-active"
            class="navbar-item"
            role="button"
            :to="{ name: 'features' }"
            >Características</router-link
          >
          <router-link
            active-class="is-active"
            class="navbar-item"
            role="button"
            :to="{ name: 'contact' }"
            >Contacto</router-link
          >
          <span class="navbar-item">
            <a
              role="button"
              class="button is-rounded is-primary"
              href="https://app-connect.datalized.cl/login"
            >
              <span class="icon">
                <font-awesome-icon icon="user" />
              </span>
              <span title="Mi cuenta">Mi cuenta</span>
            </a>
          </span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { connectLogo } from "@/assets/images";

export default {
  name: "NavBar",
  data: () => {
    return {
      connectLogo: connectLogo,
      currentRoute: null,
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters("root", {
      isActive: "getActiveMenu",
    }),
  },
  methods: {
    ...mapActions("root", ["setActiveMenu"]),
  },

  created: function () {
    this.currentRoute = this.$router.currentRoute.name;
    this.setActiveMenu(this.currentRoute);
  },
};
</script>

<style lang="scss" module></style>
